module.exports = __webpack_public_path__ + "img/mdm-deploy-5.7cab5e3f.webp";